(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.MutatingDots = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MutatingDots = undefined;
  var _react2 = _interopRequireDefault(_react);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var MutatingDots = exports.MutatingDots = function MutatingDots(props) {
    return _react2.default.createElement("svg", {
      id: "goo-loader",
      width: props.width,
      height: props.height,
      "aria-label": props.label
    }, _react2.default.createElement("filter", {
      id: "fancy-goo"
    }, _react2.default.createElement("feGaussianBlur", {
      "in": "SourceGraphic",
      stdDeviation: "6",
      result: "blur"
    }), _react2.default.createElement("feColorMatrix", {
      "in": "blur",
      mode: "matrix",
      values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
      result: "goo"
    }), _react2.default.createElement("feComposite", {
      "in": "SourceGraphic",
      in2: "goo",
      operator: "atop"
    })), _react2.default.createElement("g", {
      filter: "url(#fancy-goo)"
    }, _react2.default.createElement("animateTransform", {
      id: "mainAnim",
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      from: "0 50 50",
      to: "359 50 50",
      dur: "1.2s",
      repeatCount: "indefinite"
    }), _react2.default.createElement("circle", {
      cx: "50%",
      cy: "40",
      r: props.radius,
      fill: props.color
    }, _react2.default.createElement("animate", {
      id: "cAnim1",
      attributeType: "XML",
      attributeName: "cy",
      dur: "0.6s",
      begin: "0;cAnim1.end+0.2s",
      calcMode: "spline",
      values: "40;20;40",
      keyTimes: "0;0.3;1",
      keySplines: "0.175, 0.885, 0.320, 1.5; 0.175, 0.885, 0.320, 1.5"
    })), _react2.default.createElement("circle", {
      cx: "50%",
      cy: "60",
      r: props.radius,
      fill: props.secondaryColor
    }, _react2.default.createElement("animate", {
      id: "cAnim2",
      attributeType: "XML",
      attributeName: "cy",
      dur: "0.6s",
      begin: "0.4s;cAnim2.end+0.2s",
      calcMode: "spline",
      values: "60;80;60",
      keyTimes: "0;0.3;1",
      keySplines: "0.175, 0.885, 0.320, 1.5;0.175, 0.885, 0.320, 1.5"
    }))));
  };
  MutatingDots.propTypes = {
    width: _propTypes2.default.number,
    secondaryColor: _propTypes2.default.string,
    height: _propTypes2.default.number,
    color: _propTypes2.default.string,
    radius: _propTypes2.default.number,
    label: _propTypes2.default.string
  };
  MutatingDots.defaultProps = {
    width: 80,
    height: 90,
    color: "green",
    radius: 11,
    secondaryColor: "green",
    label: "audio-loading"
  };
});